"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.initializeState = initializeState;
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _selectFilter = require("./select-filter.utils");
var _constants = require("../../constants");
function initializeState(filterData, labelFactory) {
  if (filterData === void 0) {
    filterData = [];
  }
  var state = (0, _selectFilter.initializeMultiSelectState)(filterData, labelFactory);
  return (0, _sortBy2.default)(state, function (_ref) {
    var code = _ref.code,
      label = _ref.label;
    return !_constants.TOP_AIRLINES.includes(String(code)) ? label : '';
  });
}